import { Button } from '../Button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog';

interface DeleteDraftDappDialogProps {
  dappName: string;
  isOpen: boolean;
  isDeleting: boolean;
  onClose: () => void;
  onDelete: () => void | Promise<void>;
}

export function DeleteDraftDappDialog({
  dappName,
  isOpen,
  isDeleting,
  onClose,
  onDelete,
}: DeleteDraftDappDialogProps) {
  return (
    <Dialog
      open={isOpen}
      onOpenChange={(open) => {
        if (!open && !isDeleting) onClose();
      }}
    >
      <DialogContent className="max-w-md gap-6 rounded-xl border-seeker-800 bg-seeker-900 p-6">
        <DialogHeader className="gap-2">
          <DialogTitle className="text-xl font-semibold text-white">
            Delete draft app?
          </DialogTitle>
          <DialogDescription className="text-sm text-seeker-400">
            This removes <span className="text-white">{dappName}</span> and its
            draft releases from the portal. Published apps cannot be deleted.
            This is a soft delete — contact support if you need the draft
            restored.
          </DialogDescription>
        </DialogHeader>

        <div className="flex flex-wrap justify-end gap-3">
          <Button
            variant="outlineMuted"
            className="min-w-[120px]"
            onClick={onClose}
            disabled={isDeleting}
          >
            Cancel
          </Button>
          <Button
            variant="dangerOutline"
            className="min-w-[120px]"
            onClick={onDelete}
            disabled={isDeleting}
            submitting={isDeleting}
          >
            Delete draft
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
